var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.46.55c.74.7 7.95 8.1 7.95 8.1.4.37.59.86.59 1.35 0 .5-.2.98-.6 1.36 0 0-7.2 7.4-7.94 8.1-.73.7-2.06.75-2.85 0-.78-.75-.85-1.8 0-2.72L11.23 10 4.6 3.26c-.85-.92-.78-1.96 0-2.71.79-.76 2.12-.7 2.85 0z"
})));
export default SvgChevronRight;